<template>
  <div class="file-dist">
    <!-- 操作栏 -->
    <div class="fd-actions">
      <div class="fd-actions-left">
        <el-button type="primary" class="fd-btn-upload" @click="goUpload"><i class="el-icon-upload2"></i> 上传报告</el-button>
        <el-select v-model="selectedWaveId" placeholder="全部波次" class="fd-wave-select" clearable @change="onWaveChange" size="medium">
          <el-option v-for="w in waves" :key="w.Id" :label="w.Name" :value="w.Id" />
        </el-select>
        <el-button class="fd-btn-refresh" @click="loadFileList"><i class="el-icon-refresh"></i> 刷新</el-button>
      </div>
      <div class="fd-actions-right">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索文件名或门店..."
          prefix-icon="el-icon-search"
          class="fd-search"
          clearable
          @input="handleSearch"
        />
      </div>
    </div>

    <!-- 已下发文件列表 -->
    <div class="fd-card">
      <div class="fd-card-header">
        <h3>已下发文件</h3>
        <span class="fd-count">共 {{ total }} 个文件</span>
      </div>
      <el-table :data="filteredList" v-loading="loading" class="fd-table">
        <el-table-column prop="fileName" label="文件名" min-width="220" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div class="fd-filename"><i class="el-icon-document"></i> {{ row.fileName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="storeCode" label="门店编码" width="110" />
        <el-table-column prop="storeName" label="门店名称" width="140" />
        <el-table-column prop="fileType" label="类型" width="80">
          <template slot-scope="{ row }">
            <span class="fd-type">{{ (row.fileType || '').toUpperCase() }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fileSize" label="大小" width="100">
          <template slot-scope="{ row }">{{ formatSize(row.fileSize) }}</template>
        </el-table-column>
        <el-table-column prop="uploadTime" label="上传时间" width="160">
          <template slot-scope="{ row }">{{ formatDate(row.uploadTime) }}</template>
        </el-table-column>
        <el-table-column prop="isDownloaded" label="下载状态" width="110">
          <template slot-scope="{ row }">
            <span :class="['fd-status', row.isDownloaded ? 'fd-status-done' : 'fd-status-pending']">
              <i class="fd-dot"></i> {{ row.isDownloaded ? '已下载' : '待下载' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="downloadCount" label="下载次数" width="90" align="center">
          <template slot-scope="{ row }">
            <span class="fd-download-count">{{ row.downloadCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <span v-if="canPreview(row)" class="fd-op-preview" @click="previewOnline(row)">预览</span>
            <span class="fd-op-download" @click="handleDownload(row)">下载</span>
            <span class="fd-op-delete" @click="deleteFile(row)"><i class="el-icon-delete"></i></span>
          </template>
        </el-table-column>
      </el-table>

      <div class="fd-pagination" v-if="total > 0">
        <span class="fd-page-info">显示第 {{ pageStart }} 至 {{ pageEnd }} 条，共 {{ total }} 条数据</span>
        <el-pagination
          v-if="total > pageSize"
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="page"
          @current-change="loadFileList"
        />
      </div>
    </div>

    <!-- 底部提示 -->
    <div class="fd-tip">
      <div class="fd-tip-icon"><i class="el-icon-info"></i></div>
      <div class="fd-tip-content">
        <div class="fd-tip-title">文件下发提示</div>
        <div class="fd-tip-desc">下发报告后，相关门店管理员将收到即时系统通知。您可以随时撤回未被下载的报告。</div>
      </div>
    </div>

    <!-- Excel 预览弹窗 -->
    <el-dialog :title="previewTitle" :visible.sync="showPreview" width="95%" top="2vh" custom-class="excel-preview-dialog" :close-on-click-modal="false" @close="onPreviewClose">
      <div v-if="previewLoading" class="preview-loading">
        <i class="el-icon-loading"></i>
        <p>正在加载文件...</p>
      </div>
      <div id="luckysheet-container" v-show="!previewLoading" style="width:100%;height:75vh;"></div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'index/axios'
import LuckyExcel from 'luckyexcel'

export default {
  name: 'FileDistribution',
  data() {
    return {
      projectId: null,
      loading: false,
      fileList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      searchKeyword: '',
      waves: [],
      selectedWaveId: null,
      showPreview: false,
      previewLoading: false,
      previewTitle: ''
    }
  },
  computed: {
    filteredList() {
      if (!this.searchKeyword) return this.fileList
      const kw = this.searchKeyword.toLowerCase()
      return this.fileList.filter(f =>
        (f.fileName || '').toLowerCase().includes(kw) ||
        (f.storeName || '').toLowerCase().includes(kw) ||
        (f.storeCode || '').toLowerCase().includes(kw)
      )
    },
    pageStart() { return (this.page - 1) * this.pageSize + 1 },
    pageEnd() { return Math.min(this.page * this.pageSize, this.total) }
  },
  mounted() {
    this.projectId = this.$route.params.projectId
    this.loadWaves()
    this.loadFileList()
  },
  methods: {
    goBack() { this.$router.push('/wodexiangmu/list') },
    goUpload() { this.$router.push({ path: '/file-dist-upload', query: { projectId: this.projectId } }) },
    handleSearch() {},
    async loadWaves() {
      try {
        const res = await axios.post('/WaveManager/wave/list', { ProjectId: Number(this.projectId), Page: 1, PageSize: 50 })
        const data = (res.data && res.data.data) || res.data || {}
        this.waves = (data.rows || data.Rows || []).map(w => ({ Id: w.id || w.Id, Name: w.name || w.Name }))
      } catch (e) { console.error('loadWaves error', e) }
    },
    onWaveChange() { this.page = 1; this.loadFileList() },
    async loadFileList() {
      this.loading = true
      try {
        const pid = Number(this.projectId)
        const params = { ProjectId: pid, Page: this.page, PageSize: this.pageSize }
        if (this.selectedWaveId) params.WaveId = this.selectedWaveId
        const res = await axios.post('/StoreFile/list', params)
        // Furion 框架包了一层: res.data = { success, message, data: { records, total } }
        const inner = (res.data && res.data.data) || res.data || res
        this.fileList = inner.records || []
        this.total = inner.total || 0
      } catch (e) { console.error('[FileDistribution] loadFileList error', e); this.fileList = [] }
      finally { this.loading = false }
    },
    previewFile(row) { if (row.fileUrl) window.open(row.fileUrl, '_blank') },
    canPreview(row) {
      const ext = (row.fileType || row.fileName || '').split('.').pop().toLowerCase()
      return ['xls', 'xlsx'].includes(ext)
    },
    previewOnline(row) {
      const id = row.id || row.Id
      if (!id) { this.$message.warning('文件链接不可用'); return }
      this.previewTitle = row.fileName || '文件预览'
      this.showPreview = true
      this.previewLoading = true

      const xhr = new XMLHttpRequest()
      xhr.open('GET', '/api/StoreFile/proxy/' + id, true)
      xhr.responseType = 'arraybuffer'
      xhr.onload = () => {
        if (xhr.status !== 200) {
          this.$message.error('文件下载失败: HTTP ' + xhr.status)
          this.previewLoading = false
          this.showPreview = false
          return
        }
        try {
          LuckyExcel.transformExcelToLucky(new Uint8Array(xhr.response), (exportJson) => {
            if (!exportJson || !exportJson.sheets || exportJson.sheets.length === 0) {
              this.$message.error('文件解析失败')
              this.showPreview = false
              return
            }
            this.previewLoading = false
            this.$nextTick(() => {
              window.luckysheet.create({
                container: 'luckysheet-container',
                data: exportJson.sheets,
                title: this.previewTitle,
                showinfobar: false,
                showsheetbar: true,
                showstatisticBar: false,
                sheetBottomConfig: false,
                allowEdit: false,
                enableAddRow: false,
                enableAddBackTop: false,
                showToolbar: false,
                showFormulaBar: false,
                row: 50,
                column: 20
              })
            })
          })
        } catch (e) {
          console.error('[Preview] parse error:', e)
          this.$message.error('文件解析失败')
          this.previewLoading = false
          this.showPreview = false
        }
      }
      xhr.onerror = () => {
        this.$message.error('文件下载失败')
        this.previewLoading = false
        this.showPreview = false
      }
      xhr.send()
    },
    onPreviewClose() {
      try { window.luckysheet.destroy() } catch (e) {}
    },
    async handleDownload(row) {
      try {
        const res = await axios.post('/StoreFile/download/' + row.id)
        const data = (res.data && res.data.data) || res.data || res
        if (data.url) window.open(data.url, '_blank')
        row.downloadCount = (row.downloadCount || 0) + 1
        row.isDownloaded = 1
      } catch (e) {
        // fallback 直接用已有 URL
        if (row.fileUrl) window.open(row.fileUrl, '_blank')
      }
    },
    async deleteFile(row) {
      try {
        await this.$confirm('确定要删除该文件吗？', '提示', { type: 'warning', customClass: 'publish-confirm-dialog' })
        await axios.post('/StoreFile/delete', { Id: row.id })
        this.$message.success('删除成功')
        this.loadFileList()
      } catch (e) { if (e !== 'cancel') this.$message.error('删除失败') }
    },
    formatSize(bytes) {
      if (!bytes) return '-'
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
    },
    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const h = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      return `${y}-${m}-${day} ${h}:${min}`
    }
  }
}
</script>

<style scoped>
.file-dist { padding: 24px 32px; background: #f5f7fa; min-height: 100vh; }
.fd-nav { display: flex; align-items: center; gap: 12px; margin-bottom: 24px; }
.fd-back { color: #3b82f6; cursor: pointer; font-size: 14px; display: flex; align-items: center; gap: 4px; }
.fd-back:hover { color: #2563eb; }
.fd-sep { color: #d1d5db; font-size: 14px; }
.fd-title { font-size: 18px; font-weight: 600; color: #1f2937; }
.fd-actions { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.fd-actions-left { display: flex; gap: 12px; }
.fd-btn-upload { border-radius: 8px !important; height: 38px !important; padding: 0 20px !important; font-size: 14px !important; font-weight: 500 !important; background: #3b82f6 !important; border-color: #3b82f6 !important; }
.fd-btn-upload:hover { background: #2563eb !important; border-color: #2563eb !important; }
.fd-btn-refresh { border-radius: 8px !important; height: 38px !important; padding: 0 20px !important; font-size: 14px !important; border-color: #d1d5db !important; color: #374151 !important; background: #fff !important; }
.fd-search { width: 260px; }
.fd-search ::v-deep .el-input__inner { border-radius: 8px !important; height: 38px !important; border-color: #e5e7eb !important; }
.fd-card { background: #fff; border-radius: 12px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,0.06); margin-bottom: 20px; }
.fd-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.fd-card-header h3 { margin: 0; font-size: 16px; font-weight: 600; color: #1f2937; }
.fd-count { font-size: 13px; color: #3b82f6; }
.fd-table ::v-deep .el-table__header th { background: #fff !important; color: #6b7280; font-weight: 500; font-size: 13px; border-bottom: 1px solid #f3f4f6; padding: 12px 0; }
.fd-table ::v-deep .el-table__body td { padding: 14px 0; border-bottom: 1px solid #f3f4f6; font-size: 14px; color: #374151; }
.fd-table ::v-deep .el-table__row:hover > td { background: #f9fafb !important; }
.fd-table ::v-deep .el-table::before { display: none; }
.fd-filename { display: flex; align-items: center; gap: 8px; color: #1f2937; font-weight: 500; }
.fd-filename i { color: #9ca3af; font-size: 16px; }
.fd-type { color: #6b7280; font-size: 13px; }
.fd-status { display: flex; align-items: center; gap: 6px; font-size: 13px; }
.fd-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }
.fd-status-done { color: #059669; } .fd-status-done .fd-dot { background: #059669; }
.fd-status-pending { color: #ea580c; } .fd-status-pending .fd-dot { background: #ea580c; }
.fd-op-download { color: #3b82f6; cursor: pointer; font-size: 14px; margin-right: 16px; }
.fd-op-download:hover { color: #2563eb; }
.fd-op-delete { color: #9ca3af; cursor: pointer; font-size: 16px; }
.fd-op-delete:hover { color: #ef4444; }
.fd-pagination { display: flex; justify-content: space-between; align-items: center; margin-top: 16px; padding-top: 16px; border-top: 1px solid #f3f4f6; }
.fd-page-info { font-size: 13px; color: #6b7280; }
.fd-pagination ::v-deep .el-pagination .btn-prev,
.fd-pagination ::v-deep .el-pagination .btn-next,
.fd-pagination ::v-deep .el-pagination .el-pager li { border-radius: 6px !important; min-width: 32px; height: 32px; line-height: 32px; }
.fd-pagination ::v-deep .el-pagination .el-pager li.active { background: #3b82f6 !important; }
.fd-tip { display: flex; gap: 14px; align-items: flex-start; background: #eff6ff; border-radius: 12px; padding: 20px 24px; }
.fd-tip-icon { flex-shrink: 0; width: 36px; height: 36px; border-radius: 50%; background: #dbeafe; display: flex; align-items: center; justify-content: center; }
.fd-tip-icon i { font-size: 18px; color: #3b82f6; }
.fd-tip-title { font-size: 15px; font-weight: 600; color: #1e40af; margin-bottom: 4px; }
.fd-tip-desc { font-size: 13px; color: #3b82f6; line-height: 1.5; }
.fd-wave-select { width: 180px; }
.fd-wave-select ::v-deep .el-input__inner { border-radius: 8px !important; height: 38px !important; border-color: #d1d5db !important; }
.fd-download-count { color: #6b7280; font-size: 13px; }
</style>

<style>
/* 确认弹窗全局样式 - 不能 scoped */
.publish-confirm-dialog { border-radius: 12px !important; overflow: hidden; width: 420px !important; }
.publish-confirm-dialog .el-message-box__header { padding: 20px 24px 10px; }
.publish-confirm-dialog .el-message-box__title { font-size: 16px; font-weight: 600; color: #1f2937; }
.publish-confirm-dialog .el-message-box__content { padding: 10px 24px 20px; font-size: 14px; color: #4b5563; }
.publish-confirm-dialog .el-message-box__btns { padding: 0 24px 20px; }
.publish-confirm-dialog .el-message-box__btns .el-button { border-radius: 8px; min-width: 80px; }
.publish-confirm-dialog .el-message-box__btns .el-button--primary { background: #3b82f6; border-color: #3b82f6; }
.publish-confirm-dialog .el-message-box__btns .el-button--primary:hover { background: #2563eb; border-color: #2563eb; }

/* 预览按钮 */
.fd-op-preview { color: #8b5cf6; cursor: pointer; font-size: 14px; margin-right: 12px; }
.fd-op-preview:hover { color: #7c3aed; }

/* Excel 预览弹窗 */
.excel-preview-dialog { border-radius: 14px !important; overflow: hidden; }
.excel-preview-dialog .el-dialog__header { padding: 16px 24px; border-bottom: 1px solid #f0f0f0; }
.excel-preview-dialog .el-dialog__title { font-size: 16px; font-weight: 600; color: #1f2937; }
.excel-preview-dialog .el-dialog__body { padding: 0; height: 80vh; overflow: hidden; }
.preview-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 300px; color: #9ca3af; }
.preview-loading i { font-size: 32px; margin-bottom: 12px; }
</style>
